const DocumentInfoRecipe = {
    $type$: 'Recipe',
    name: 'DocumentInfo',
    rule: [
        {
            itemprop: 'document',
            itemtype: { type: 'referenceToBlob' }
        }
    ]
};
// Export recipes
const DocumentRecipes = [DocumentInfoRecipe];
export default DocumentRecipes;
//# sourceMappingURL=DocumentRecipes_1_0_0.js.map